import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import {darken, lighten, alpha} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { v4 as uuidv4 } from 'uuid';

import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import Collapse from '@mui/material/Collapse';

import Bs4ReportGeneric from './Bs4ReportGeneric';
import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch'
import { getBoxSx, UxAccordion, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';

import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4I18N from '../Bs4I18N';

const TYPE_BS4REPORTTYPE51 = 'type_Bs4ReportType51';

//Kanban
export default class Bs4ReportType51 extends Bs4ReportGeneric {  
  static COLUMN_DATA = 'data_';
  static COLUMN_MENU = 'menu_';

  createModel() {
    super.createModel();    
    this.columns = this.getColumns()
    this.setColumnsMenu();    
    this.isDragDisabled = !this.getPageParam('allowdragdrop');
  }

  /////////////////// form field /////////////////////////////
  getValue() {
    return null;
  }

  resetOriginalValue() {
  }  

  isDifferentValues (oldValue, newVaue) {
    return false;
  }

  clear() {
  }
  //////////////////////////////////////////////////////////

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportType51',
    body: {        
      Report51: {
        droppable: {
          margin: 1,
          padding: 1,
          elevation: 2,
          borderRadius: 2,
          minWidth: 200,
        },
        draggable: {
          margin: 1,
          padding: 1,          
          elevation: 2,
          borderRadius: 1,
        },
      },        
    }
  };

  getUxTemplateEditor = (uxEditor) => {    
    const type = TYPE_BS4REPORTTYPE51;
    const eds = [{
      label: Bs4I18N.getTT('Droppable', 'Droppable', 'Bs4ReportType51'),
      types: [TYPE_BS4REPORTTYPE51],
      onReset: () => this.uxTemplate.body.Report51.droppable = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report51.droppable)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report51;
        
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.droppable} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.droppable} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.droppable} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.droppable} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.droppable} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.droppable} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.droppable} name='minWidth'/>
            <uxEditor.ViewCssText types={type} value={uxBody.droppable} name='mx' title='marginesy X'/>
            <uxEditor.ViewCssText types={type} value={uxBody.droppable} name='my' title='marginesy Y'/>
            <uxEditor.ViewCssText types={type} value={uxBody.droppable} name='padding'/>
          </Box>
        );
      },
    }, {
      label: Bs4I18N.getTT('Draggable', 'Draggable', 'Bs4ReportType51'),
      types: [TYPE_BS4REPORTTYPE51],
      uxTemplate: this.uxTemplate,
      onReset: () => this.uxTemplate.body.Report51.draggable = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report51.draggable)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report51;

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.draggable} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.draggable} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.draggable} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.draggable} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.draggable} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.draggable} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.draggable} name='minWidth'/>
            <uxEditor.ViewCssText types={type} value={uxBody.draggable} name='mx' title='marginesy X'/>
            <uxEditor.ViewCssText types={type} value={uxBody.draggable} name='my' title='marginesy Y'/>
            <uxEditor.ViewCssText types={type} value={uxBody.draggable} name='padding'/>
          </Box>
        );
      },
    }];

    return [{
      label: Bs4I18N.getTT('Report51', 'Report51', 'Bs4ReportType51'),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4REPORTTYPE51],
      Content: (props) => {
        const [expanded, setExpanded] = React.useState(eds[0].label);
        const {} = useStateUxTemplate(type);
        
        const handleChange = (panel) => (event, isExpanded) => {
          setExpanded(isExpanded ? panel : false);
        };

        return (
          <React.Fragment>
            {eds.map((ux, index) => {
              return (
                <UxAccordion 
                  key={index} 
                  label={ux.label} 
                  types={ux.types}
                  expanded={expanded} 
                  onChange={handleChange} 
                  onReset={ux.onReset}
                >
                  <ux.Content />
                </UxAccordion>
              )
            })}
          </React.Fragment>
        )
      },
    }]
  }

  data = [];

  getColumns() {   
    for (const store of Bs4Kartoteka.get(this.bs4KartotekaId)?.message?._Komunikat?.ext_store ||  []) {
      if (store.id === 'kanban') return store.items.map(item => {
        //id, etykieta, opis tekstowy, akronim ikony, kod html kolorów tła- czcionki- opacity
        const [id, title, text, icon, style] = item;
        return {
          index: String(Bs4ReportType51.COLUMN_DATA+id), 
          id,
          title, 
          text, 
          icon, 
          style, 
          bs4columntotals: '', 
          items: [],
        }
      });
    }
    return [];
  }  

  getColumn(index) {
    if (index.startsWith(Bs4ReportType51.COLUMN_DATA)) {
      return this.columns.find(column => column.index === index);
    }
    if (index.startsWith(Bs4ReportType51.COLUMN_MENU)) {
      return this.columnsMenu.find(column => column.index === index);
    }
  }

  reload = () => {
  }

  fetchCriteriaVals() {
		const filterCriteria = this.defaultCriteriaVals();    				
		if (this.remembersettings) filterCriteria.remembersettings = 1;
		//filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
		return filterCriteria;
	}

  packColumnLayout() {
    const tablica = this.getColDef().map((column, index) => {
      return {
        dataIndex: column.dataIndex,
        hidden: false,
        id: column.dataIndex, 
        index: index + 1,
        width: this.bs4ViewProps?.width,
      }
    })
    
    return JSON.stringify(tablica);
  }

  defaultCriteriaVals() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    return {
      currCardViewId: this.bs4KartotekaId,
      optionId: this.optionId,
      currFormId: this.formId,
      parametrJs: JSON.stringify(bs4Option.bs4Form.gatherCriteriaValues()),
    }
  }

  updateColumns(data, bs4columntotals, setShiftTime) {    
    this.columns.forEach((column) => {
      column.items = data.filter(item => item.column === column.id)
      column.bs4columntotals = bs4columntotals?.[column.id];
      return column;
    })

    this.setColumnsMenu();
    setShiftTime(new Date());
  }

  fetchData(setShiftTime) {    
    const baseValues = this.fetchCriteriaVals(); //this.defaultCriteriaVals();        
    const newBaseValues = Bs4MainDispatch.getParserParams(baseValues, this.bs4KartotekaId);
    const formData = new FormData();
    for (let [key, value] of Object.entries(newBaseValues)) formData.append(key, value);
    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {      
      try {
        const returnedJson = JSON.parse(returnedText);
        //console.log('....kanban.fetch..', returnedJson);
        if (!Array.isArray(returnedJson.dane) || returnedJson.dane.length < 1) returnedJson.dane = [];
        const data = returnedJson.dane.map(record => {
          record.id = record.id || uuidv4();
          return record;
        })
        const bs4columntotals = returnedJson?.metaData?.bs4columntotals;
        //console.log('....kanban.data...', data, bs4columntotals);
        
        this.updateColumns(data, bs4columntotals, setShiftTime);
      } catch (error) {
        //console.log(returnedText);
        console.log(error);        
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  runListOption(item, rowId) { 
		const details = { 
			reportOptionId: item?.bs4Id, 
			selectedRows: [rowId],
			storeData: this.getData(),
      ukladKryt: JSON.stringify(this.fetchCriteriaVals()),
			ukladKolumn: this.packColumnLayout(),
			ukladSort: JSON.stringify(this.gridSortToHidden()),
      currFormId: this.formId,
		}

		Bs4MainDispatch.commandParser('Bs4ReportOption', details, this.bs4KartotekaId);
    this.atrybProgressbar(item);
	}

  onMenuClick = (item) => {
    this.runListOption(item);
  }

  bs4DragDrop = (result, sColumn, dColumn, sItem) => {
    if (result.destination.droppableId.startsWith(Bs4ReportType51.COLUMN_MENU)) {
      const menuItem = dColumn.menuItem
      //console.log('... COLUMN_MENU ...', menuItem, sItem)
      this.runListOption(menuItem, sItem.id)
      return;
    } else if (result.destination.droppableId.startsWith(Bs4ReportType51.COLUMN_DATA)) {
      let afterItem = null;
      let dItem = null;
      let beforeItem = null;      
      for (const item of dColumn.items) {        
        if (dItem) {
          beforeItem = item;
          break;
        }

        if (item.id  === sItem.id) {
          dItem = item;
          continue;
        } 

        afterItem = item;
      }

      let dropPosition = 'after';
      let targetRowId = 0;
      if (beforeItem) {
        targetRowId = beforeItem.id;
        dropPosition = 'before';
      } else if (afterItem) {
        targetRowId = afterItem.id;
        dropPosition = 'after';
      }

      const details = {
        currCardViewId: this.bs4KartotekaId,
        currOptionId: this.optionId,
        currFormId: this.formId,

        sourceRowId: sItem.id, 
        targetRowId: targetRowId, 
        dropPosition: dropPosition, 
        sourceColumnId: sColumn.id,
        targetColumnId: dColumn.id,
      };

      Bs4MainDispatch.commandParser('Bs4DragDrop', details, this.bs4KartotekaId);      
      return;
    }    
  }  

  ViewDroppable = (props) => {
    const report = this;
    const theme = useTheme();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE51);
    const boxSx = React.useMemo(() => {
      return {
        backgroundColor: lighten(theme.palette.primary.main, 0.8),
        color: theme.palette.text.primary,
        ...getBoxSx(this.uxTemplate?.body?.Report51?.droppable, theme),
        ...getBoxSx(props?.column?.style, theme),
        flex: 1
      }
    }, [dateTimeStamp, theme, props?.column?.style]);
    

    const addClick = (event, column) => {
      if (props.addClick) props.addClick(event, column);
    }

    return (
      <Droppable 
        droppableId={String(props.index)} 
        ignoreContainerClipping={true}
      >
        {(provided, snapshot) => (
          <Box
            ref={provided.innerRef} 
            {...provided.droppableProps} 
            sx={boxSx}
          >
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} flexWrap='wrap'>
              {props.column.icon ? <Box component='span' className={props.column.icon}/> : null}
              <Typography variant='body1'>{props.column.title}</Typography>
            </Stack>
            <Typography variant='body2'>{props.column.bs4columntotals}</Typography>
            {props.column.items.map((item, index) => <report.ViewDraggable key={String(item.id)} index={index} item={item}/>)}
            {provided.placeholder}
            {props.showPlus &&
            <Stack direction="row" justifyContent="center" alignItems="center">
              <IconButton size='small' onClick={(event) => addClick(event, props.column)} sx={{color: 'inherit'}}>
                <Box component='i' className="fa-regular fa-plus"/>
              </IconButton>
            </Stack>
            }                                  
          </Box>                  
        )}
      </Droppable>
    )
  }

  ViewDraggable = (props) => {
    const report = this;
    const [expanded, setExpanded] = React.useState(false);
    const theme = useTheme();
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORTTYPE51);
    const boxSx = React.useMemo(() => {
      return {        
        backgroundColor: lighten(theme.palette.primary.main, 0.7),
        color: theme.palette.text.primary,
        ...getBoxSx(this.uxTemplate?.body?.Report51?.draggable, theme),
        ...getBoxSx(props?.item?.xx555, theme),
      }
    }, [dateTimeStamp, theme, props?.item?.xx555]);

    const itemClick = (e) => {
      Bs4MainDispatch.commandParserAfter(report.bs4KartotekaId);
    }

    const handleMouseOver = (e) => {
      const willExpanded = e.type === 'mouseenter' ? true : false;
      //setExpanded(willExpanded );
    }

    const handleClickExpand = (event, a) => {
      setExpanded(!expanded);
    }

    return (
      <Draggable 
        key={String(props.item.id)} 
        draggableId={String(props.item.id)} 
        index={props.index}
        isDragDisabled={report.isDragDisabled}
      >
        {(provided) => (
          <Box 
            ref={provided.innerRef} 
            {...provided.draggableProps} 
            {...provided.dragHandleProps} 
            sx={boxSx}
            onClick={itemClick}
            className={props.item.class}
            onMouseEnter={handleMouseOver}
            onMouseLeave={handleMouseOver}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography sx={{flex: 1}} dangerouslySetInnerHTML={{__html: props.item.msg}}/>
              {props.item.alt ? 
              <IconButton onClick={handleClickExpand} sx={{color: 'inherit'}}>
                {expanded ? <ExpandLess/> : <ExpandMore/>}
              </IconButton> 
              : null}
            </Stack>
            {props.item.alt ? 
              <Collapse sx={{width: '100%'}} in={expanded}>
                <Typography sx={{width: '100%'}} dangerouslySetInnerHTML={{__html: props.item.alt}}/>
              </Collapse>
            : null}
          </Box>
        )}
      </Draggable>
    )
  }
  
  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const [shiftTime, setShiftTime] = React.useState(new Date());   

    React.useEffect(() => {
      this.reload = () => {
        console.log('... reload kanban ...')
        this.fetchData(setShiftTime);
      }

      report.reload();
    }, [])

    const onDragEnd = (result) => {      
      if (!result.destination) return;
      const sColumn = this.getColumn(result.source.droppableId);
      const dColumn = this.getColumn(result.destination.droppableId);
      const [sItem] = sColumn.items.splice(result.source.index, 1);
      dColumn.items.splice(result.destination.index, 0, sItem); 
      report.bs4DragDrop(result, sColumn, dColumn, sItem);      
      setShiftTime(new Date())
    }

    const handleBeforeCapture = (result) => {
      console.log('... BeforeCapture ...', result)
    }

    const handleDragUpdate = (result, a) => {
      console.log('... DragUpdate ...', result, a)
    }

    const itemClick = (e) => {
      Bs4MainDispatch.commandParserAfter(report.bs4KartotekaId);
    }

    const addClick = (event, column) => {
      //console.log('..add..', event, {...column}, column?.id);
      //- ikonka plusa nie działa - powinna wywoływać request taki sam jak dawniej KontrolkaWybor.js dodając jeszcze ID kolumny - oprogramuje to gdy doda Pan request (Bs4FieldIconPlus)
      Bs4MainDispatch.commandParser('Bs4FieldIconPlus', { currFormId: this.formId, columnId: column.id }, this.props.bs4KartotekaId);
    }
    
    console.log('... KANBAN ... view',);
    
    //className={column.className}
    //className={item.class}

    return (      
      <Box 
        ref={ref} 
        height='100%' 
        width='100%' 
        display='flex' 
        flexDirection="column" 
        overflow='hidden'
        px={props.uxKartoteka?.spacing}
      >
        <Box display="flex" flexDirection="row" flexWrap='wrap' gap={0.5} p={0.5} alignItems='center'>
          <Bs4Criteria {...report.props}/>
          <report.ReportBs4HorizontalMenu bs4Menu={report.menuItems}/>
        </Box>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>
        <DragDropContext 
          onDragEnd={onDragEnd} 
          onBeforeCapture={handleBeforeCapture} 
          onDragUpdate={handleDragUpdate}
        >
          <Box flex={1} overflow='auto'>
            <Box display='flex' flexDirection='row'>
              {report.columns.map(column =>
                <report.ViewDroppable 
                  key={column.index} 
                  index={column.index}
                  column={column}
                  addClick={addClick}
                  showPlus={report.getPageParam('show_plus')}
                />
              )}
            </Box>
          </Box>
          <Box width='100%' display='flex' flexDirection='row' flexWrap='wrap' gap={4} p={report.columnsMenu.length > 0 ? 2 : 0}>
            {report.columnsMenu.map((column, index) =>
              <report.ViewDroppable 
                key={column.index}
                index={column.index}
                column={column}
                addClick={addClick} 
              />
            )}
          </Box>          
        </DragDropContext>     
      </Box>
    );
  });
}